import React, { useEffect, useRef } from "react";
import { useAuth } from "shared/contexts/AuthContext";
import { startLogin } from "shared/auth/auth";
import { GlobalStyles } from "styles/globalStyles";
import { theme } from "styles/theme";
import { ThemeProvider } from "styled-components";
import { Page, HeaderArea, Content } from "pages/Account/styles";
import { HeaderTemplate } from "Components/templates/Header";
import { AccountLoader } from "pages/Account/AccountLoader";

/**
 * Componente RequireAuth
 *
 * Guarda uma rota protegida, exigindo autenticação. Caso o usuário esteja
 * deslogado, inicia o fluxo de login substituindo a página atual no
 * histórico, para o voltar do navegador não cair nela de novo, e preserva
 * a URL atual (pathname + search + hash) para retorno após a autenticação.
 *
 * Enquanto carrega, exibe a casca de carregamento da conta.
 */
export const RequireAuth: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { status } = useAuth();
  const hasTriggeredLoginRef = useRef(false);

  useEffect(() => {
    if (status === "anonymous" && !hasTriggeredLoginRef.current) {
      hasTriggeredLoginRef.current = true;
      startLogin({ source: "alerts", replaceCurrentPage: true });
    }
  }, [status]);

  // Carregando ou anônimo: exibe o loader
  if (status === "loading" || status === "anonymous") {
    return (
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Page>
          <HeaderArea>
            <HeaderTemplate />
          </HeaderArea>
          <Content>
            <AccountLoader
              label={
                status === "anonymous"
                  ? "Redirecionando para o login..."
                  : "Carregando..."
              }
              fullPage
            />
          </Content>
        </Page>
      </ThemeProvider>
    );
  }

  // Autenticado: renderiza os filhos
  return <>{children}</>;
};
